<template>
  <div class="fileModel">
    <div class="content">
      <el-form :model="form">
        <el-form-item label="文件*：" label-width="120px">
          <el-upload class="upload-demo filesupload" ref="upload" :limit="1" :on-change="handleChange" :file-list="fileList" :action="uploadUrl" :multiple="false" :auto-upload="false" :on-success="handleSuccess">
            <div v-if="!loading" class="btn item-btn">选择文件</div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，图片长宽比为：4:1</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="row-item footer" style="width: 97%; margin-top: 10px; text-align: center">
      <div class="element-list jb-bg btn" @click="affirm">确认</div>
      <div class="element-list btn" @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
import { uploadLogo } from "@/api/systemApi";
import axios from "@/util/request";
export default {
  data() {
    return {
      form: {
        typeName: "",
      },
      loading: false,
      fileList: [],
      fileItem: "", //文件成功返回的数据
      uploadUrl: "/admin/sys-file/upload", //上传地址
    };
  },
  methods: {
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleSuccess(res) {
      this.fileItem = res.data[0];
    },
    affirm() {
      if (this.fileList.length == 0) {
        this.$message.error("请选择需要上传的文件");
        return;
      }
      this.myupload(this.fileList[0].raw);
    },
    cancel() {
      this.$emit("cancel");
    },
    myupload(file) {
      let that = this;
      const form = new FormData();
      form.append("file", file);
      axios({
        url: that.uploadUrl,
        headers: { "Content-Type": "multipart/form-data" },
        method: "post",
        data: form,
      })
        .then((res) => {
          if (res.succeed) {
            let fileName = res.data.fileName;
            let dt = {
              logoPath: fileName,
              deptId: this.$store.state.user.userInfo.deptId,
            };
            uploadLogo(dt).then((res2) => {
              if (res2.succeed) {
                that.$emit("fileChange", res2.data);
              }
            });
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch((data) => {
          that.$message.error("上传失败,请重新上传图片!");
        });
    },
  },
};
</script>

<style lang="less" scopde>
.fileModel {
  color: #74c8fe;
  .row-item {
    margin-left: 2%;
    display: flex;
  }
  .btn {
    width: 150px;
    border: 2px solid #0090f0;
    border-radius: 6px;
    height: 30px;
    line-height: 30px;
    margin: 0 10px;
    text-align: center;
    cursor: pointer;
  }
  .jb-bg {
    background-image: linear-gradient(#0479b4, #02407e);
  }
  .footer {
    display: flex;
    justify-content: center;
  }
  .content {
    width: 95%;
    .item-btn {
      width: 250px;
      height: 36px;
      line-height: 36px;
      margin: 0;
    }
    /deep/ .el-form-item__label {
      color: #74c8fe;
    }
    /deep/ .el-input__inner {
      border: 2px solid #0090f0;
      color: #74c8fe;
      background-color: transparent !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/guidance/components/uploadLogo.vue